import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'src/app/app-config';
import { JsLoaderService } from 'src/shared/services/js-loader.service';

@Component({
  selector: 'app-directives',
  templateUrl: './directives.component.html'
})
export class DirectivesComponent implements OnInit {

  constructor(private jsLoader: JsLoaderService, private config: AppConfig) { }
  CAdocumentPath;
  UNMemoCADocumenPath;
  UNMemoAuditingDocumentPath;
  CovidVaccinationForTravelPath;
  SCOUNMemoCADocumenPath;
  BloodGroupRequestPath;

  ConfidentialitySOPPath;
  ConfidentialityUndertakingPath;
  MD9Path;
  MD10Path;
  UserRecordAccessPath;
  RegionalDelegationOfMedicalEntitlementsPath;

  IsPortal: boolean;
  ngOnInit() {
    this.jsLoader.loadScripts();
    this.IsPortal = this.config.IsPortal;

    if (!this.IsPortal) {
      this.CAdocumentPath = this.config.CADocumentURL;
      this.UNMemoCADocumenPath = this.config.UNMemoCADocumentURL;
      this.SCOUNMemoCADocumenPath = this.config.SCOUNMemoCADocumentURL;
      this.UNMemoAuditingDocumentPath = this.config.UNMemoAuditingDocumentURL;
      this.CovidVaccinationForTravelPath = this.config.CovidVaccinationForTravelURL;
      this.BloodGroupRequestPath = this.config.BloodGroupRequestURL;
      this.MD9Path = this.config.MD9URL;
      this.MD10Path = this.config.MD10URL;
      this.ConfidentialityUndertakingPath = this.config.ConfidentialityUndertakingURL;
      this.RegionalDelegationOfMedicalEntitlementsPath = this.config.RegionalDelegationOfMedicalEntitlements;
    }
    else {
      this.CAdocumentPath = this.config.CADocumentURLPortal;
      this.UNMemoCADocumenPath = this.config.UNMemoCADocumentURLPortal;
      this.SCOUNMemoCADocumenPath = this.config.SCOUNMemoCADocumentURLPortal;
      this.UNMemoAuditingDocumentPath = this.config.UNMemoAuditingDocumentURLPortal;
      this.CovidVaccinationForTravelPath = this.config.CovidVaccinationForTravelURLPortal;
      this.BloodGroupRequestPath = this.config.BloodGroupRequestURLPortal;

      this.MD9Path = this.config.MD9URLPortal;
      this.MD10Path = this.config.MD10URLPortal;
      this.RegionalDelegationOfMedicalEntitlementsPath = this.config.RegionalDelegationOfMedicalEntitlements;
    }
  }

}
